import { Card } from "@/components/ui/card";

export default function PoliticaCookiesPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-headline text-4xl font-bold text-primary mb-2 text-center">Política de Cookies</h1>
        <p className="text-center text-muted-foreground mb-8">Última actualización: 24 de agosto de 2026</p>
        <Card className="prose dark:prose-invert max-w-none p-6">
          <h2>1. ¿QUÉ SON LAS COOKIES?</h2>
          <p>
            Una cookie es un pequeño fichero que un sitio web guarda en tu dispositivo. Junto con otras
            tecnologías similares (como el almacenamiento local del navegador), permiten recordar
            información sobre tu visita. En Jartiland utilizamos el mínimo imprescindible.
          </p>

          <h2>2. TIPOS DE TECNOLOGÍAS QUE UTILIZAMOS</h2>
          <ul>
            <li>
              <strong>Técnicas / esenciales:</strong> imprescindibles para el funcionamiento del sitio. Se
              usan para gestionar tu sesión y mantener tu inicio de sesión en «Jartinet». Sin ellas no
              podrías acceder a las áreas privadas. No requieren consentimiento.
            </li>
            <li>
              <strong>De preferencias / consentimiento:</strong> guardamos en el almacenamiento local de tu
              navegador tu elección sobre las cookies (clave <code>cookie_consent</code>), para no volver a
              mostrarte el aviso en cada visita.
            </li>
            <li>
              <strong>De terceros:</strong>
              <ul>
                <li>
                  <strong>Firebase / Google:</strong> la plataforma se apoya en servicios de Firebase (de
                  Google) para autenticación y base de datos, que pueden establecer cookies necesarias para
                  su funcionamiento. Más información en la
                  {" "}<a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">política de cookies de Google</a>.
                </li>
                <li>
                  <strong>YouTube:</strong> algunas páginas incrustan vídeos de YouTube. Para reducir el
                  seguimiento, los incrustamos en <strong>modo de privacidad mejorada</strong>
                  {" "}(<code>youtube-nocookie.com</code>), que evita cookies de seguimiento hasta que
                  reproduces el vídeo.
                </li>
              </ul>
            </li>
          </ul>

          <h2>3. TU CONSENTIMIENTO</h2>
          <p>
            Al entrar por primera vez verás un aviso donde puedes <strong>Aceptar</strong> o
            {" "}<strong>Rechazar</strong> el uso de cookies no esenciales. Las cookies estrictamente
            técnicas se instalan siempre porque son necesarias para que el sitio funcione. Puedes cambiar tu
            decisión en cualquier momento borrando los datos del sitio en tu navegador.
          </p>

          <h2>4. CÓMO GESTIONAR LAS COOKIES EN TU NAVEGADOR</h2>
          <p>Puedes permitir, bloquear o eliminar las cookies desde la configuración de tu navegador:</p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          </ul>
          <p>
            Ten en cuenta que, si bloqueas las cookies técnicas, algunas funcionalidades como el inicio de
            sesión en «Jartinet» podrían dejar de funcionar.
          </p>

          <h2>5. ACTUALIZACIONES</h2>
          <p>
            Podemos actualizar esta Política de Cookies. Te recomendamos revisarla periódicamente para estar
            informado de cómo y para qué usamos las cookies.
          </p>
        </Card>
      </div>
    </div>
  );
}
